import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Fab from '@material-ui/core/Fab';
import { Box } from '@material-ui/core';
import Popover from '@material-ui/core/Popover';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    background: 'none',
    width: 240,
  },
  fabRoot: {
    width: 'auto',
    boxShadow: 'none',
    background: theme.palette.KenColors.kenWhite,
    height: 'auto',
    padding: 10,
    borderRadius: 'unset',
    fontSize: 12,
    color: theme.palette.KenColors.neutral400,
    position: 'fixed',
    bottom: 20,
    right: 32,
    borderRadius: 3,
    textTransform: 'Capitalize',
    '&:hover': {
      background: theme.palette.KenColors.kenWhite,
    },
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
  },
  contentText: {
    padding: '4px 7px',
    fontSize: 12,
    color: theme.palette.KenColors.neutral400,
  },
  detailsRoot: {
    background: theme.palette.KenColors.kenWhite,
    width: 280,
    padding: '6px 12px',
  },
  paper: {
    width: 240,
    boxShadow: 'none',
  },
  contentColor: {
    width: '20px',
    height: '20px',
    // background: theme.palette.KenColors.tertiaryOrange75,
    borderRadius: 3,
    padding: 7,
  },
  // backBtn: {
  //   padding: 10,
  //   fontSize: 14,
  //   textAlign: 'end',
  // },
}));

export default function LegendCard(props) {
  const classes = useStyles();

  const { data = [], label } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const { t } = useTranslation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box data-testid="LegendCard">
      <Fab
        classes={{ root: classes.fabRoot }}
        onClick={handleClick}
        data-testid="label"
      >
        {label || t('headings:Legend')}
      </Fab>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        classes={{ root: classes.root }}
        classes={{ paper: classes.paper }}
      >
        {/* <Typography className={classes.backBtn} onClose={handleClose}>back</Typography> */}
        {data.map((el, index) => (
          <Box className={classes.wrapper}>
            <Typography
              className={classes.contentColor}
              style={{ backgroundColor: el.color }}
            ></Typography>
            <Typography
              className={classes.contentText}
              data-testid="contentText"
            >
              {el.subject}
            </Typography>
          </Box>
        ))}
      </Popover>
    </Box>
  );
}
